import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { consentCookieKey, ScanDataKey, LocaleKey } from '@/enum';
const config = {
  root: '#cookie',

  guiOptions: {
    consentModal: {
      layout: 'bar',
      position: 'bottom',
    },
    preferencesModal: {
      layout: 'box',
    },
  },

  cookie: {
    name: consentCookieKey,
    useLocalStorage: true,
  },

  onFirstConsent: (value) => {
    const { cookie } = value;
    const { services } = cookie;
    const { functional } = services;

    if (!functional.includes(LocaleKey)) {
      localStorage.removeItem(LocaleKey);
    }

    if (!functional.includes(ScanDataKey)) {
      localStorage.removeItem(ScanDataKey);
    }
  },

  categories: {
    necessary: {
      readOnly: true,
      enabled: true,
    },
    functional: {
      enabled: true,
      services: {
        Locale: {
          label: 'Locale',
        },
        ScanData: {
          label: 'Scan Data',
        },
      },
    },
  },

  language: {
    default: 'en',

    translations: {
      en: {
        consentModal: {
          title: 'Your Privacy Choices',
          description: 'We use cookies to ensure you get the best experience on our website. By continuing to use our site, you agree to our use of cookies.',
          acceptAllBtn: 'Accept',
          acceptNecessaryBtn: 'Reject',
          showPreferencesBtn: 'Manage preferences',
          closeIconLabel: 'Reject all and close',
          footer: `
            <a href="/privacy-policy">Privacy</a>
            <a href="/terms">Terms</a>
          `,
        },
        preferencesModal: {
          title: 'Your Privacy Choices',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          sections: [
            {
              title: 'Privacy usage',
              description:
                'When you visit any of our websites, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences, or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and manage your preferences. Please note, blocking some types of cookies may impact your experience of the site and the services we are able to offer.',
            },
            {
              title: 'Strictly necessary cookies',
              description:
                'When you visit any of our websites, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences, or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and manage your preferences. Please note, blocking some types of cookies may impact your experience of the site and the services we are able to offer.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Functional LocalStorage',
              linkedCategory: 'functional',
              description:
                'Functional LocalStorage allow us to remember choices you make about the kind of experience you want on our site and to provide you with a more personalized experience. For example, a functional cookie is required to remember which language you prefer.',
              cookieTable: {
                headers: {
                  name: 'Key',
                  domain: 'Domain',
                  desc: 'Description',
                },
                body: [
                  {
                    name: LocaleKey,
                    domain: window.location.hostname,
                    desc: 'Language of current user',
                  },
                  {
                    name: ScanDataKey,
                    domain: window.location.hostname,
                    desc: 'Scan Data of current task, to resume the task later',
                  },
                ],
              },
            },
            {
              title: 'More information',
              description: `For any queries in relation to our policy on cookies and your choices, please <a class="cc__link" href="mailto:${process.env.VUE_APP_SUPPORT_EMAIL}">contact me</a>.`,
            },
          ],
        },
      },
    },
  },
};

CookieConsent.run(config);
